export default __webpack_public_path__ + "static/media/slogan.0dfbb547.png";